import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { AuthGuardService } from '../../../../../core/services/auth/auth-guard.service';
import { PlatformService } from '../../../../../core/services/platform.service';
import { LandingPageDataService } from '../../services/landing-post-data.service';
import { LandingPostService } from '../../services/landing-post.service';
import { ShareOnService } from '../../../../../core/services/share.service';
import { ClipboardService } from '../../../../../core/services/clipboard.service';

@Component({
  selector: 'app-post-activity',
  templateUrl: './post-activity.component.html',
  styleUrl: './post-activity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PostActivityComponent {
  shareModal: boolean = false;

  constructor(
    private landingPostService: LandingPostService,
    public landingPageDataService: LandingPageDataService,
    private authGuardService: AuthGuardService,
    private pt: PlatformService,
    private shareOnService: ShareOnService,
    private clipboardService: ClipboardService,
  ) {}

  ngOnInit() {
    if (this.pt.isBrowser) {
      this.likeCheck();
    }
  }

  async likeToggle() {
    if (!this.authGuardService.isLoggedIn()) {
      this.authGuardService.showLoginModal.set(true);
      return;
    }

    try {
      if (this.landingPageDataService.isLiked()) {
        this.landingPageDataService.isLiked.set(false);
        await this.disLike();
      } else {
        this.landingPageDataService.isLiked.set(true);
        await this.like();
      }
    } catch (error) {
      this.landingPageDataService.isLiked.set(
        !this.landingPageDataService.isLiked(),
      );
    }
  }

  async like() {
    await this.landingPostService.like(
      this.landingPageDataService.details()._id,
      this.landingPageDataService.isQrCode(),
    );
  }

  async disLike() {
    await this.landingPostService.disLike(
      this.landingPageDataService.details()._id,
      this.landingPageDataService.isQrCode(),
    );
  }

  async likeCheck() {
    if (!this.authGuardService.isLoggedIn()) {
      return;
    }

    var res = await this.landingPostService.likeCheck(
      this.landingPageDataService.details()._id,
      this.landingPageDataService.isQrCode(),
    );
    this.landingPageDataService.isLiked.set(res.result);
  }

  shareToggle() {
    this.shareModal = !this.shareModal;
  }

  share(on: 'facebook' | 'whatsapp' | 'messenger') {
    switch (on) {
      case 'facebook':
        this.shareOnService.facebook(this.landingPageDataService.details().url);
        break;

      case 'whatsapp':
        this.shareOnService.whatsapp(this.landingPageDataService.details().url);
        break;

      case 'messenger':
        this.shareOnService.messenger(
          this.landingPageDataService.details().url,
        );
        break;
    }
    this.shareModal = false;
  }

  copyLink() {
    this.clipboardService.copy(this.landingPageDataService.details().url);
  }
}
